import {ensureHierarchy, isEmpty, mergeTo} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';
import {Localization} from '#core/localization.js';

import SCHEMA from './user-settings.schema.yaml';

class UserSettingsFeature extends AbstractFeature {
    get name() {
        return 'User Settings';
    }

    get configSchema() {
        return SCHEMA;
    }

    updateMojitoConfig(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.stores');
        const {locales, timeZone, timeOffset, oddsFormats, defaultOddsFormat} = this.config;

        mergeTo(configurations, {
            userSettings: {
                dateTimeFormat: {
                    locales: isEmpty(locales) ? Localization.getCurrentLocale() : locales,
                    ...(timeZone && {timeZone}),
                    ...(timeOffset && {timeOffset}),
                },
                defaultOddsFormat,
                oddsFormats,
            },
        });

        super.updateMojitoConfig(mojitoConfig);
    }
}

new UserSettingsFeature(allFeatures);
